module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-551.17cd7572.jpg";